// extracted by mini-css-extract-plugin
module.exports = {"page":"river-3-plus-portable-power-station_page__zGvSu"};